<p-panel>
    <div class="container-fluid gap-5">
        <div class="row">
            <div class="col">
                <app-reactive-form-builder
                    #builderRef
                    (stableValueChanges)="stableValueChanges($event)"
                    (internalLifecycleEvents)="onReactiveFormLifecycleEvent($event)"
                    (afterSend)="onAfterSend($event)"
                    (goBack)="goBack()"
                    [form]="form.formFields"
                    [id]="reactiveFormRecordId"
                    [request]="request"
                    [getRequest]="trabajadoresApi.maquinariaGET">

                    <section slot="before-actions" class="col-12 mt-4 mb-4" [class.d-none]="appName !== 'manezylozano'">
                        <div class="card border-0 shadow-sm boquilla-summary">
                            <div class="card-header bg-white">
                                <div class="d-flex flex-column flex-md-row justify-content-between align-items-md-center">
                                    <div class="mb-2 mb-md-0">
                                        <h5 class="mb-1">BOQUILLAS ATOMIZADOR: HCI60/AMT</h5>
                                        <small class="text-muted">Gestiona las boquillas guardadas para esta maquinaria.</small>
                                    </div>

                                    <button class="btn btn-sm btn-success" type="button" (click)="showAddBoquilla()">
                                        <i class="fa fa-plus mr-1" aria-hidden="true"></i>
                                        A&ntilde;adir
                                    </button>
                                </div>
                            </div>

                            <div class="card-body">
                                <div *ngIf="!boquillasList.length" class="alert alert-light border mb-0">
                                    Esta m&aacute;quina no tiene boquillas.
                                </div>

                                <div *ngIf="boquillasList.length > 0" class="row">
                                    <div *ngFor="let boquilla of boquillasList; let i = index" class="col-12 col-lg-6 mb-3">
                                        <div class="card h-100 boquilla-summary-card">
                                            <div class="card-body d-flex align-items-start">
                                                <button
                                                    type="button"
                                                    class="btn btn-link text-left p-0 flex-grow-1 boquilla-summary-button"
                                                    (click)="showAddBoquilla(boquilla)">
                                                    <div class="d-flex align-items-center mb-2">
                                                        <span class="badge badge-primary mr-2">#{{i + 1}}</span>
                                                        <strong class="text-dark">{{boquilla?.nombre || '(sin nombre)'}}</strong>
                                                    </div>

                                                    <div class="small text-muted mb-2" *ngIf="boquilla?.hci_format">
                                                        <span class="badge badge-light border text-dark mr-1 mb-1">HCI60</span>
                                                        {{boquilla?.hci_format}}
                                                    </div>

                                                    <div class="small text-muted" *ngIf="boquilla?.amt_format">
                                                        <span class="badge badge-light border text-dark mr-1 mb-1">AMT</span>
                                                        {{boquilla?.amt_format}}
                                                    </div>
                                                </button>

                                                <button
                                                    type="button"
                                                    class="btn btn-sm btn-outline-danger ml-2"
                                                    title="Eliminar boquilla"
                                                    (click)="deleteBoquilla(boquilla)">
                                                    <i class="fa fa-times" aria-hidden="true"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </app-reactive-form-builder>
            </div>
        </div>
    </div>
</p-panel>

<p-dialog
  [(visible)]="isShowingBoquilla"
  header="Boquilla"
  [modal]="true"
  [draggable]="false"
  [dismissableMask]="true"
  [breakpoints]="{'1200px': '88vw', '768px': '96vw', '576px': '99vw'}"
  [style]="{ width: '64rem', 'max-width': '96vw' }"
  styleClass="boquilla-dialog"
  (onShow)="scrollToTop()">
  <div class="boquilla-dialog__content bg-white p-3 p-md-4">
    <div class="form-group my-3 boquilla-dialog__field">
      <label for="nombre_boquilla">Nombre o identificador:<b class="text-danger">*</b></label>
      <input
        pInputText
        class="form-control"
        type="text"
        placeholder="..."
        name="nombre_boquilla"
        [(ngModel)]="boquillaModel.nombre" />
    </div>

    <div class="d-none d-md-block">
      <div class="table-responsive mb-4">
        <table class="table table-sm table-bordered text-center boquilla-desktop-table">
          <tr>
            <td rowspan="2" class="font-weight-bold align-middle boquilla-row-title">
              <span class="px-1 py-2">HCI60</span>
            </td>
            <td><span class="px-1 py-2">COLOR</span></td>
            <td *ngFor="let option of hciBoquillaOptions" [style.background-color]="option.color"></td>
            <td></td>
            <td class="text-nowrap font-weight-bold text-dark">TOTAL HCI 60</td>
          </tr>
          <tr>
            <td class="text-center text-nowrap">
              <span class="px-1 py-2">N&ordm; BOQUILLAS</span>
            </td>
            <td *ngFor="let option of hciBoquillaOptions">
              <input pInput class="form-control form-control-sm" type="number" [(ngModel)]="boquillaModel.hci[option.key]" (change)="getTotales()" />
            </td>
            <td></td>
            <td>
              <span class="px-1 py-2 font-weight-bold text-dark">{{totalHCI || 0}}</span>
            </td>
          </tr>
          <tr>
            <td colspan="14" class="p-2"></td>
          </tr>
          <tr>
            <td rowspan="3" class="font-weight-bold align-middle boquilla-row-title">
              <span class="px-1 py-2">CER&Aacute;MICA</span>
            </td>
            <td><span class="px-1 py-2">DI&Aacute;METRO</span></td>
            <td *ngFor="let option of amtBoquillaOptions">{{option.diameter}}</td>
          </tr>
          <tr>
            <td><span class="px-1 py-2">DIFUSOR</span></td>
            <td *ngFor="let option of amtBoquillaOptions">{{option.diffuser}}</td>
            <td class="text-nowrap font-weight-bold text-dark">
              <span class="px-1 py-2">TOTAL AMT</span>
            </td>
          </tr>
          <tr>
            <td class="text-center text-nowrap">
              <span class="px-1 py-2">N&ordm; BOQUILLAS</span>
            </td>
            <td *ngFor="let option of amtBoquillaOptions">
              <input pInput class="form-control form-control-sm" type="number" [(ngModel)]="boquillaModel.amt[option.key]" (change)="getTotales()" />
            </td>
            <td>
              <span class="px-1 py-2 font-weight-bold text-dark">{{totalAMT || 0}}</span>
            </td>
          </tr>
        </table>
      </div>

      <div class="table-responsive mb-4">
        <table class="table table-sm table-bordered text-center boquilla-pressure-table">
          <tr>
            <td class="font-weight-bold boquilla-row-title">PRESI&Oacute;N (BAR)</td>
            <td *ngFor="let i of pressureValues">{{i}}</td>
          </tr>
          <tr class="font-weight-bold">
            <td>Caudal (l/min)</td>
            <td *ngFor="let i of pressureValues">{{totalCaudales[i] || 0.00}}</td>
          </tr>
        </table>
      </div>
    </div>

    <div class="d-md-none">
      <div class="card mb-3">
        <div class="card-header d-flex justify-content-between align-items-center py-2">
          <span class="font-weight-bold text-dark">HCI60</span>
          <span class="badge badge-light text-dark border boquilla-total-badge">Total HCI 60: {{totalHCI || 0}}</span>
        </div>
        <div class="card-body p-2 p-sm-3">
          <div class="text-uppercase small text-muted mb-2">N&ordm; boquillas por color</div>

          <div class="list-group list-group-flush">
            <div class="list-group-item px-0 py-2" *ngFor="let option of hciBoquillaOptions">
              <div class="row no-gutters align-items-center">
                <div class="col-auto pr-2">
                  <span class="boquilla-color-swatch" [style.background-color]="option.color"></span>
                </div>
                <div class="col pr-2">
                  <div class="font-weight-bold text-dark">{{option.label}}</div>
                  <small class="text-muted">HCI60</small>
                </div>
                <div class="col-5 col-sm-4">
                  <input pInput class="form-control form-control-sm" type="number" [(ngModel)]="boquillaModel.hci[option.key]" (change)="getTotales()" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card mb-3">
        <div class="card-header d-flex justify-content-between align-items-center py-2">
          <span class="font-weight-bold text-dark">CER&Aacute;MICA</span>
          <span class="badge badge-light text-dark border boquilla-total-badge">Total AMT: {{totalAMT || 0}}</span>
        </div>
        <div class="card-body p-2 p-sm-3">
          <div class="text-uppercase small text-muted mb-2">N&ordm; boquillas por di&aacute;metro y difusor</div>

          <div class="list-group list-group-flush">
            <div class="list-group-item px-0 py-2" *ngFor="let option of amtBoquillaOptions">
              <div class="row no-gutters align-items-center">
                <div class="col pr-2">
                  <div><span class="text-muted">Di&aacute;metro:</span> <strong class="text-dark">{{option.diameter}}</strong></div>
                  <small class="text-muted">Difusor: {{option.diffuser}}</small>
                </div>
                <div class="col-5 col-sm-4">
                  <input pInput class="form-control form-control-sm" type="number" [(ngModel)]="boquillaModel.amt[option.key]" (change)="getTotales()" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card mb-4">
        <div class="card-header py-2 font-weight-bold text-dark">Caudal por presi&oacute;n</div>
        <div class="card-body p-2 p-sm-3">
          <div class="row">
            <div class="col-6 col-sm-4 mb-2" *ngFor="let i of pressureValues">
              <div class="border rounded text-center py-2 px-1 h-100">
                <div class="small text-muted">{{i}} BAR</div>
                <div class="font-weight-bold text-dark">{{totalCaudales[i] || 0.00}}</div>
                <small class="text-muted">l/min</small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row justify-content-center">
      <div class="col-12 col-sm-auto mb-2 mb-sm-0">
        <button class="btn btn-dark w-100" type="button" (click)="cancelar()">Cancelar</button>
      </div>
      <div class="col-12 col-sm-auto mb-2 mb-sm-0">
        <button class="btn btn-primary w-100" type="button" (click)="addBoquilla()" [disabled]="isPerformingBoquilla">
          {{isPerformingBoquilla ? 'Guardando...' : 'Guardar'}}
        </button>
      </div>
      <div *ngIf="boquillaModel?.id" class="col-12 col-sm-auto">
        <button class="btn btn-danger w-100" type="button" (click)="deleteBoquilla(boquillaModel)">Eliminar</button>
      </div>
    </div>
  </div>
</p-dialog>
